module.exports = __webpack_public_path__ + "static/media/csm-clock-home.5341103d.svg";